import { useEffect } from 'react'
import '../../styles/pages/membership/style.css'
import AboveAll from '../../components/AboveAll'
import CustomForms from '../../components/Forms'
// import Footer from '../../components/Footer'
import FAQ from '../../components/FAQ'

const MEMBERSHIP_DESCRIPTION = 'Join Life Sports Club, New Cairo, a 25-acre, referral-based club with 20+ sports, sports academies, pools, tennis, padel & football. Apply today.'
const DEFAULT_DESCRIPTION = 'Life Sports Club, New Cairo, 25 acres, 20+ sports, sports academies for kids & adults, Olympic pools, tennis, padel, football & more.'

const FAQ_JSON_LD = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'Where is Life Sports Club located?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Life Sports Club is located in New Cairo, Egypt — a 25-acre world-class sports facility.',
      },
    },
    {
      '@type': 'Question',
      name: 'What sports are available at the club?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'We offer 20+ sports including tennis, padel, football, swimming in Olympic-standard pools, squash, pickleball, and many more.',
      },
    },
    {
      '@type': 'Question',
      name: 'How do I become a member?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Life Sports Club is a referral-based club. You need a valid referral code from an existing member to apply for membership.',
      },
    },
    {
      '@type': 'Question',
      name: 'Are there sports academies for kids and adults?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Yes — we offer professional sports academies for both kids and adults across multiple disciplines, coached by experienced trainers.',
      },
    },
    {
      '@type': 'Question',
      name: 'Does the club have swimming pools?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Yes, Life Sports Club features Olympic-standard swimming pools available to all members.',
      },
    },
  ],
}

export default function Membership(){
	document.title = 'LSC | Membership'

	useEffect(() => {
		// Override description for this page
		const descTag = document.querySelector('meta[name="description"]')
		if (descTag) descTag.setAttribute('content', MEMBERSHIP_DESCRIPTION)

		// Inject FAQPage JSON-LD
		const script = document.createElement('script')
		script.type = 'application/ld+json'
		script.id = 'faq-json-ld'
		script.textContent = JSON.stringify(FAQ_JSON_LD)
		document.head.appendChild(script)

		return () => {
			// Restore default description on unmount
			if (descTag) descTag.setAttribute('content', DEFAULT_DESCRIPTION)
			const injected = document.getElementById('faq-json-ld')
			if (injected) injected.remove()
		}
	}, [])

	return (
		<>
			<AboveAll/>
			<div className="daApp">
				<div className='formsWrapper'>
					<CustomForms classes={'forms'} show={'referral'}/>
				</div>
				<FAQ />
				{/* <Footer/> */}
			</div>
		</>
	)
}